import { isEqual } from 'lodash'
import React, { useMemo } from 'react'
import { CSSTransition, TransitionGroup } from 'react-transition-group'
import styled from 'styled-components'
import { useDispatch, useSelector } from '../../store/hooks'
import { useBreakpoint } from '../../store/hooks/uiHooks'
import { ANIMATION_SCALE, breakpoint, device } from '../../style'
import FinalView from '../FinalView'
import { PriceLayer } from '../PriceLayer'
import { ViewSwitcher } from './ViewSwitcher'

const transitionDuration = 300 * ANIMATION_SCALE

const ConstelaUI = styled(function ConstelaUI(props) {
  const showSwitcher = useBreakpoint('tablet')
  const visibleOverlays = useSelector((state) => {
    return {
      final: state.ui.showFinal,
      globalProperties: state.ui.expert.showProperties?.module === 'global',
      applications: state.ui.expert.showApplications
    }
  }, isEqual)
  const dispatch = useDispatch()
  const closeOverlay = useMemo(() => {
    if (visibleOverlays.final) {
      return () => {
        dispatch({
          type: 'Ui/HideFinal'
        })
      }
    }
    if (visibleOverlays.globalProperties) {
      return () => {
        dispatch({
          type: 'UI/Expert/ShowPropertyOverlay',
          payload: undefined
        })
      }
    }
    if (visibleOverlays.applications) {
      return () =>
        dispatch({
          type: 'UI/Expert/ShowApplicationOverlay',
          show: false
        })
    }
  }, [dispatch, visibleOverlays.applications, visibleOverlays.final, visibleOverlays.globalProperties])

  const screenWidth = useSelector((state) => state.ui.screenSize.width)

  return (
    <TransitionGroup {...props}>
      {React.Children.map(props.children, (child) => {
        if ('key' in child) {
          return (
            <CSSTransition key={child.key} classNames="cs-mode" timeout={transitionDuration}>
              {child}
            </CSSTransition>
          )
        }
        return child
      })}
      {showSwitcher && <ViewSwitcher />}
      {screenWidth >= breakpoint.tablet && (
        <>
          <FinalView />
        </>
      )}
      <PriceLayer visible={!!closeOverlay} closeOverlay={closeOverlay} />
    </TransitionGroup>
  )
})`
  height: calc(100vh - 55px);
  position: absolute;
  top: 0;
  left: 0px;
  right: 0px;
  bottom: 0px;
  pointer-events: none;

  ${ViewSwitcher} {
    position: absolute;
    margin-left: 40px;
    bottom: 40px;
    right: 40px;
    width: calc(100% - 80px);

    @media ${device.laptop} {
      width: auto;
    }
  }

  .cs-mode-enter {
    opacity: 0;
  }

  .cs-mode-enter-active {
    opacity: 1;
    transition: opacity ${({ duration = 300 }) => duration}ms;
  }

  .cs-mode-exit {
    opacity: 1;
  }

  .cs-mode-exit-active {
    opacity: 0;
    transition: opacity ${({ duration = 300 }) => duration}ms;
  }
`
export default ConstelaUI
